var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftChevronBlack = function SvgLeftChevronBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.582 20 1.085-1.052L9.502 12l7.165-6.949L15.582 4l-8.249 8 8.249 8Z",
    fill: "#231F20"
  })));
};
export { SvgLeftChevronBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS41ODE5IDIwTDE2LjY2NjcgMTguOTQ3OUw5LjUwMTUzIDEyLjAwMDRMMTYuNjY2NyA1LjA1MTM1TDE1LjU4MTkgNEw3LjMzMzQyIDEyLjAwMDRMMTUuNTgxOSAyMFoiIGZpbGw9IiMyMzFGMjAiLz4KPC9zdmc+Cg==";